import { Card, DataTable, Layout, Page, Text } from '@shopify/polaris'
import { useEffect, useState } from 'react'

import { useAdminApi } from '../hooks/useAdminApi'

export default function AdminDashboardPage() {
  const { getShopsStats } = useAdminApi()
  const [stats, setStats] = useState<any>(null)

  useEffect(() => {
    const fetchStats = async () => {
      const response = await getShopsStats()
      if (response.success) {
        setStats(response.data)
      }
    }

    fetchStats()
  }, [])

  return (
    <Page title="Admin Dashboard">
      <Layout>
        {stats && (
          <Layout.Section>
            <Card>
              <Text as="h3" variant="headingMd">
                Shop Statistics
              </Text>
              <div style={{ marginTop: '16px' }}>
                <DataTable
                  columnContentTypes={['text', 'numeric']}
                  headings={['Metric', 'Count']}
                  rows={[
                    ['Total Shops', stats.total_shops || 0],
                    ['Installed Shops', stats.installed_shops || 0],
                    ['Shopify Plus Shops', stats.shopify_plus_shops || 0],
                    [
                      'Partner Development Shops',
                      stats.partner_development_shops || 0,
                    ],
                  ]}
                />
              </div>
            </Card>
          </Layout.Section>
        )}
      </Layout>
    </Page>
  )
}
